/** Beat fires ``send_due_scheduled_invites`` every 10 minutes on the clock. */

const GRID_MINUTES = 10;

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

export function formatLocalDateTime(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Round *up* to the next :00 / :10 / :20 … Already-on-grid stays put. */
export function snapDateForward(d: Date): Date {
  const snapped = new Date(d);
  snapped.setSeconds(0, 0);
  const remainder = snapped.getMinutes() % GRID_MINUTES;
  if (remainder === 0) return snapped;
  snapped.setMinutes(snapped.getMinutes() + (GRID_MINUTES - remainder));
  return snapped;
}

/** Snap a `datetime-local` value forward onto the 10-minute grid. */
export function snapLocalDateTimeForward(value: string): string {
  if (!value) return value;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return formatLocalDateTime(snapDateForward(d));
}

/** Local `datetime-local` value for "now + minutes" (not snapped). */
export function localDateTimeValue(minutesFromNow = 0): string {
  const d = new Date(Date.now() + minutesFromNow * 60_000);
  d.setSeconds(0, 0);
  return formatLocalDateTime(d);
}

/** An ISO timestamp as a local-time `datetime-local` input value. */
export function isoToLocalInputValue(iso: string): string {
  return formatLocalDateTime(new Date(iso));
}

/** Local `datetime-local` value at least `minutesFromNow` out, on the grid. */
export function nextGridLocalDateTime(minutesFromNow = 0): string {
  const d = snapDateForward(new Date(Date.now() + minutesFromNow * 60_000));
  if (d.getTime() <= Date.now()) {
    d.setMinutes(d.getMinutes() + GRID_MINUTES);
  }
  return formatLocalDateTime(d);
}
